module.exports = __webpack_public_path__ + "img/r4_921_resilientcity.fbec92fe.jpg";